import { render, staticRenderFns } from "./ThankYouComponent.vue?vue&type=template&id=774fccda&scoped=true"
import script from "./ThankYouComponent.vue?vue&type=script&lang=js"
export * from "./ThankYouComponent.vue?vue&type=script&lang=js"
import style0 from "./ThankYouComponent.vue?vue&type=style&index=0&id=774fccda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fccda",
  null
  
)

export default component.exports